import React from 'react';
import { CircularProgress } from '@mui/material';

const OppyWave: React.FC = () => {
  return <CircularProgress />;
};

export default OppyWave;